export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<g clip-path="url(#clip0_134_5507)">
			<path
				d="M16.125 6.25C16.125 4.78906 15.3086 3.45703 14.0625 2.68359C12.7734 1.95312 11.1836 1.95312 9.9375 2.68359C8.64844 3.45703 7.875 4.78906 7.875 6.25C7.875 7.75391 8.64844 9.08594 9.9375 9.85938C11.1836 10.5898 12.7734 10.5898 14.0625 9.85938C15.3086 9.08594 16.125 7.75391 16.125 6.25ZM6.5 6.25C6.5 4.31641 7.53125 2.51172 9.25 1.52344C10.9258 0.535156 13.0312 0.535156 14.75 1.52344C16.4258 2.51172 17.5 4.31641 17.5 6.25C17.5 8.22656 16.4258 10.0312 14.75 11.0195C13.0312 12.0078 10.9258 12.0078 9.25 11.0195C7.53125 10.0312 6.5 8.22656 6.5 6.25ZM3.75 21.375H20.25C20.1641 17.9805 17.3711 15.1875 13.9336 15.1875H10.0234C6.58594 15.1875 3.79297 17.9805 3.75 21.375ZM2.375 21.5039C2.375 17.25 5.76953 13.8125 10.0234 13.8125H13.9336C18.1875 13.8125 21.625 17.25 21.625 21.5039C21.625 22.1914 21.0234 22.75 20.3359 22.75H3.62109C2.93359 22.75 2.375 22.1914 2.375 21.5039Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_134_5507">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
